<template>
    <div>

        <div v-if="action.isCompleted">
            <ActionProviderMessageComplete :action="action"/>

            <v-list v-if="savedEvent">
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-calendar</v-icon>
                    </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                            <strong>Data appuntamento:</strong> 
                            {{ date(savedEvent.start_time) }}
                        </v-list-item-title>
                      </v-list-item-content>
                </v-list-item>
                <v-list-item>
                    <v-list-item-icon>
                        <v-icon>mdi-clock</v-icon>
                    </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>
                            <strong>Orario appuntamento:</strong> 
                            {{ time(savedEvent.start_time) }}
                        </v-list-item-title>
                      </v-list-item-content>
                </v-list-item>
            </v-list>

        </div>

        <!-- Calendly inline widget -->
        <div class="calendly-inline-widget" 
             :data-url="url" 
             :style="css"
             v-else></div>

        <ActionProviderLoading :value="isLoading"/>

    </div>
</template>

<script>
import API from '@/api'

import moment from 'moment'

import actionProvider from '@/mixins/actionProvider'

export default 
{
   name: 'ActionProviderCalendly',

   mixins: [ actionProvider ],

   components: 
   {

   },

   data: () => ({
    hasListeners: false,
    isLoading: false,
    script: null
   }),

   props: {
    
   },

   computed: 
   {
    calendlyEvent()
    {
        return this.action.componentMeta.calendly_event
    },

    css()
    {
        return {
            height: '650px'
        }
    },

    formData()
    {
        const formData = this.action.componentMeta.form_data || {}

        let encoded = ""

        for (var key in formData)
            // formData.hasOwnProperty(key)
            if (formData[key])
                encoded += `${key}=${encodeURI(formData[key])}&`

        return encoded
    },

    savedEvent()
    {
        return this.action.componentMeta.event
    },

    url()
    {
        const base = 'https://calendly.com/', 
              event = this.calendlyEvent,
              color = this.$vuetify.theme.themes.light.primary,
              formData = this.formData,
              url = `${base}${event}?hide_event_type_details=1&hide_gdpr_banner=1&primary_color=${color}&${formData}`

        return url
    }

   },

   methods:
   {

    addListeners()
    {
        if( this.hasListeners )
            return

        window.addEventListener("message", (e)=>{
            if( !this.isCalendlyEvent(e) )
                return

            const eventType = e.data.event,
                  payload = e.data.payload

            if( eventType === 'calendly.event_scheduled' )
                this.saveEvent(payload)
        })

        this.hasListeners = true
    },

    isCalendlyEvent(e)
    {
        return e.origin === "https://calendly.com" 
                && e.data.event 
                && e.data.event.indexOf("calendly.") === 0
    },
    
    loadJs()
    {
        if( this.script )
            this.script.remove()

        let js = document.createElement('script')
            js.src = "https://assets.calendly.com/assets/external/widget.js"
            js.type = "text/javascript"

        document.body.appendChild(js)

        this.script = js
    },

    saveEvent(payload)
    {
        const apiUrl = payload.event.uri,
              actionId = this.action.id,
              data = { apiUrl }

        this.isLoading = true

        API.action.complete(actionId, data)
                  .then(({ data })=>{

                    this.$emit( 'completed', data )

                  })
                  .catch((err)=>{
                    
                    this.$emit( 'error', err )

                  })
                  .finally(()=>this.isLoading=false)
    },

    date(datetime)
    {
        return moment(datetime).format('DD/MM/YYYY')
    },

    time(datetime)
    {
        return moment(datetime).format('HH:mm')
    }

   },

   mounted()
   {
    this.loadJs()

    this.addListeners()
   }
}
</script>